import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { controls: "" }
const _hoisted_2 = ["src"]



type IContentMessage = {
  content: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'audio',
  props: {
    content: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("audio", _hoisted_1, [
    _createElementVNode("source", { src: __props.content }, null, 8, _hoisted_2)
  ]))
}
}

})